/**
 * Implementation of percent field that handles min / max, and uses percentage number format
 * (wrapper around react-number-format) for number formatting.
 */

import React, { Component } from 'react';
import { TextField } from '@mui/material';
import PercentageNumberFormat from './PercentageNumberFormat';

class PercentageTextField extends Component {

    render () {
        const { id, className, value, label, error, errorMsg, showErrMsg, disabled, onChange, allowNegative, 
                maxValue, maxEnterValue, maxErrMsg, minEnterValue, minValue, minErrMsg, textAlign, ...other } = this.props;

        // There are multiple ways of handling min/max value. These can be set on the component props, but
        // this causes undesirable behavior when typing.  Another solution is to use color coding and
        // error messages - that is, if a value is invalid, show the field in red, and provide an error
        // message.

        // The approach will be:
        // - if minValue is provided, and the value is less than the min value, set the field to error state
        //   and indicate why.
        // - if maxValue is provided, and the value is greater than the max value, set the field to error state
        //   and indicate why.
        // - there might be another validation issue, in which case the higher order component will pass
        //   an error state and a reason to be displayed.

        let theError    = error; // Passed error info.  If passed, overrides other error checks in this component.
        let theErrorMsg = errorMsg;
    
        if (theError !== true) {
            if (maxValue != null) {
                if (value > maxValue) {
                    theError = true;
                    if (maxErrMsg != null) {
                        theErrorMsg = maxErrMsg;
                    } else {
                        theErrorMsg = 'Value cannot exceed ' + Number(maxValue).toLocaleString("en-US", {minimumFractionDigits: 2}) + '%';
                    }
                }
            }

            if (minValue != null && theError !== true) {
                if (value < minValue) {
                    theError = true;
                    if (minErrMsg != null) {
                        theErrorMsg = minErrMsg;
                    } else {
                        theErrorMsg = 'Value cannot be less than ' + Number(minValue).toLocaleString("en-US", {minimumFractionDigits: 2}) + '%';
                    }
                }
            }
        }

        let theTextAlign = 'left';
        if (textAlign != null) {
            theTextAlign = textAlign;
        }
        let fieldLabel = label;
        if (!fieldLabel) {
            fieldLabel = '';
        }

        if (theError && showErrMsg && theErrorMsg != null) {
            return(
                <TextField id={id}
                    className={className}
                    value={value}
                    label={fieldLabel}
                    error={theError}
                    helperText={theErrorMsg}
                    onChange={(e) => onChange(e)}
                    InputProps={{
                        inputComponent: PercentageNumberFormat,
                    }}  
                    inputProps={{
                        allowNegative: allowNegative,
                        maxValue: maxEnterValue != null ? maxEnterValue : null,
                        minValue: minEnterValue != null ? minEnterValue : null,
                        style: {textAlign: theTextAlign}
                    }}
                    disabled={disabled}
                />
            );
        } else {
            return(
                <TextField id={id}
                    className={className}
                    value={value}
                    label={fieldLabel}
                    error={theError}
                    onChange={(e) => onChange(e)}
                    InputProps={{
                        inputComponent: PercentageNumberFormat,
                    }}  
                    inputProps={{
                        allowNegative: allowNegative,
                        maxValue: maxEnterValue != null ? maxEnterValue : null,
                        minValue: minEnterValue != null ? minEnterValue : null,
                        style: {textAlign: theTextAlign}
                    }}
                    disabled={disabled}
                />
            );
        }
    }
}

export default PercentageTextField;


